import React from 'react';
import { LogoMark } from './LogoMark';
interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  body?: string;
  center?: boolean;
  className?: string;
}
export function SectionHeading({
  eyebrow,
  title,
  body,
  center = false,
  className = ''
}: SectionHeadingProps) {
  return <div className={`${center ? 'mx-auto text-center' : ''} max-w-2xl ${className}`} data-id="element-128">
      {eyebrow && <p className={`flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-warmgray ${center ? 'justify-center' : ''}`} data-id="element-129">
          <LogoMark className="h-3.5 w-3.5" data-id="element-130" /> {eyebrow}
        </p>}
      <h2 className="mt-3 text-3xl font-black leading-[1.1] tracking-tight text-charcoal sm:text-4xl" data-id="element-131">
        {title}
      </h2>
      {body && <p className="mt-4 text-base leading-relaxed text-warmgray" data-id="element-132">{body}</p>}
    </div>;
}